module.exports = __webpack_public_path__ + "img/2.b41c283b.png";